import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["as", "children"],
    _excluded2 = ["theme", "$styles"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import styled from 'styled-components';
import convertLayoutProps from '../../utils/convertLayoutProps';
import { jsx as _jsx } from "react/jsx-runtime";
var BoxBase = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
      Element = _ref$as === void 0 ? 'div' : _ref$as,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(Element, _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    children: children
  }));
});
BoxBase.displayName = 'BoxBase';
var Box = styled(BoxBase).withConfig({
  displayName: "Box",
  componentId: "sc-g760pt-0"
})(function (_ref2) {
  var theme = _ref2.theme,
      $styles = _ref2.$styles,
      props = _objectWithoutProperties(_ref2, _excluded2);

  return theme.normalizeStyles(_objectSpread(_objectSpread({}, convertLayoutProps(props)), $styles));
});
export default Box;